// ==================== Navigation.js ====================
import React from 'react';

const Navigation = ({ showFloatingNav, activeSection, scrollToSection }) => (
  <nav className={`
    fixed top-6 left-1/2 transform -translate-x-1/2 z-50 transition-all duration-500
    ${showFloatingNav ? 'translate-y-0 opacity-100' : '-translate-y-20 opacity-0'}
  `}>
    <div className="bg-white/95 backdrop-blur-sm rounded-2xl px-8 py-4 shadow-xl border border-gray-100">
      <div className="flex items-center gap-8">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl flex items-center justify-center relative overflow-hidden"
               style={{
                 background: 'linear-gradient(135deg, #8B5CF6 0%, #3B82F6 100%)',
                 boxShadow: '0 4px 16px rgba(139, 92, 246, 0.3)'
               }}>
            <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
              <div className="text-2xl font-bold"
                   style={{
                     background: 'linear-gradient(135deg, #8B5CF6 0%, #3B82F6 100%)',
                     WebkitBackgroundClip: 'text',
                     WebkitTextFillColor: 'transparent',
                     fontFamily: 'Inter, sans-serif'
                   }}>
                Z
              </div>
            </div>
          </div>
          <span className="text-xl font-bold text-gray-900">ZENTRY</span>
        </div>
        
        <div className="flex items-center gap-6">
          {['Home', 'Process', 'Pricing', 'Companies', 'About'].map((item, index) => (
            <button
              key={item}
              onClick={() => scrollToSection(index)}
              className={`
                px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300
                ${activeSection === index 
                  ? "bg-gradient-to-r from-purple-600 to-blue-600 text-white" 
                  : "text-gray-600 hover:text-gray-900 hover:bg-gray-100"
                }
              `}
            >
              {item}
            </button>
          ))}
        </div>
      </div>
    </div>
  </nav>
);

export default Navigation;
